import { render } from "./PanelLayout.vue?vue&type=template&id=bab095a4&scoped=true"
const script = {}

import "./PanelLayout.vue?vue&type=style&index=0&id=bab095a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.30_vue@3.5.27_typescript@5.9.3__webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bab095a4"]])

export default __exports__